import service from "@/utils/index"
import service1 from "@/utils/res2.js"
// 获取token
export const getToken = (data) => {
  return service({
    method: "post",
    url: "/Login/get_token",
    data
  })
}
// 入口配置
export const getInlet = (data) => {
  return service({
    method: "post",
    url: "/Sys/get_sys_conf",
    data
  })
}
// 免密登录
export const getAssisted = (data) => {
  return service({
    method: "post",
    url: "/sys/get_assisted",
    data
  })
}
export const venderSurveySave = (data) => {
  return service({
    method: "post",
    url: "/index/vender_survey_save",
    data
  })
}
// 首页数据
export const getIndex = (data) => {
  return service({
    method: "post",
    url: "/Index/workspace_n",
    data
  })
}
export const getInto = (data) => {
  return service({
    method: "post",
    url: "/income/withdraw_list",
    data
  })
}
export const getInt = (data) => {
  return service({
    method: "post",
    url: "/income/profit_list",
    data
  })
}
export const getIntDay = (data) => {
  return service({
    method: "post",
    url: "/income/profit_day_list",
    data
  })
}
export const getInts = (data) => {
  return service({
    method: "post",
    url: "/income/district_profit",
    data
  })
}
export const getInmx = (data) => {
  return service({
    method: "post",
    url: "/income/district_profit_list",
    data
  })
}
export const getInx = (data) => {
  return service({
    method: "post",
    url: "/income/withdraw_add",
    data
  })
}
export const getInxs = (data) => {
  return service({
    method: "post",
    url: "/income/withdraw_online_add",
    data
  })
}
export const getInp = (data) => {
  return service({
    method: "post",
    url: "/income/profit_withdraw_auto",
    data
  })
}
export const getLo = (data) => {
  return service({
    method: "post",
    url: "/Sys/vender_list",
    data
  })
}
export const getMs = (data) => {
  return service({
    method: "post",
    url: "/tool/tool_user_list",
    data
  })
}
export const getMdel = (data) => {
  return service({
    method: "post",
    url: "/tool/tool_user_del",
    data
  })
}
export const getMss = (data) => {
  return service({
    method: "post",
    url: "/tool/tool_user_audit",
    data
  })
}
export const getXp = (data) => {
  return service({
    method: "post",
    url: "/district/district_money_order",
    data
  })
}
export const getTc = (data) => {
  return service({
    method: "post",
    url: "/index/new_dialog_check",
    data
  })
}
// 获取分账统计数据
export const getData = (data) => {
  return service1({
    method: "post",
    url: "/profit_info/index",
    data
  })
}
// 获取分账数据
export const getDataList = (data) => {
  return service1({
    method: "post",
    url: "/profit_info/profit_list",
    data
  })
}
// 获取分账数据汇总
export const getDataT = (data) => {
  return service1({
    method: "post",
    url: "/profit_info/profit_total",
    data
  })
}
// 获取分账信息
export const getAccdata = (data) => {
  return service1({
    method: "post",
    url: "/profit_info/profit_info",
    data
  })
}
// 获取分账订单
export const getAccOrder = (data) => {
  return service1({
    method: "post",
    url: "/profit_info/profit_order",
    data
  })
}
// 导出分账订单
export const downAccOrder = (data) => {
  return service1({
    method: "post",
    url: "/profit_info/profit_order_export ",
    data
  })
}